import { config } from 'CorePackage/MainModule/constants/config';

import { ISystemInoperabilityResponse } from '../interfaces/ISystemInoperabilityResponse';
import { handleResponse } from '../../MainModule/common/handleResponse';

export async function fetchSystemInoperabilityList(
  sort?: string,
  pageNumber?: number,
): Promise<ISystemInoperabilityResponse> {
  const paramsPrefix = sort || typeof pageNumber === 'number' ? '?' : '';
  const params = sort ? `order=${sort}` : '';
  const page = pageNumber !== undefined ? `page=${pageNumber}` : '';

  return fetch(`${config.server}/system-inoperability${paramsPrefix}${page}&${params}&size=9`, {
    method: 'GET',
    credentials: 'include',
  }).then(handleResponse);
}
